// import '@babel/polyfill';
// import 'whatwg-fetch';
import './publicPath';

import 'antd/dist/antd.less';

// Polyfill
import 'ts-polyfill/lib/es2015-core';
import 'ts-polyfill/lib/es2015-collection';
import 'ts-polyfill/lib/es2015-iterable';
import 'ts-polyfill/lib/es2015-promise';
import 'ts-polyfill/lib/es2015-reflect';
import 'ts-polyfill/lib/es2016-array-include';
import 'ts-polyfill/lib/es2017-object';
import 'core-js/es/symbol';

// Locale
import 'common/validation/initYup';
import { IntlProvider } from 'client/core/intl/IntlProvider';

import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import { store } from 'client/core/store/configureReduxStore';
import { Routes } from './routes/Routes';
import { NetworkProvider } from './core/network/context/NetworkContext';
import { networkState } from './core/network/context/configureNetworkState';
import { BreadcrumbProvider } from './core/router/breadcrumb/BreadcrumbContext';
import { ClientConfigLoader } from './components/schema/config/ClientConfigLoader';
import { appConfig } from './core/appConfig';

import './ui/AntStyles.scss';

// importiamo le immagini per le comunicazioni email agli utenti
import './ui/email/EmailImageImporter.scss';

export function App() {
  return (
    <BrowserRouter basename={appConfig.publicPath}>
      <Provider store={store}>
        <IntlProvider>
          <NetworkProvider value={networkState}>
            <BreadcrumbProvider>
              <ClientConfigLoader>
                <Routes />
              </ClientConfigLoader>
            </BreadcrumbProvider>
          </NetworkProvider>
        </IntlProvider>
      </Provider>
    </BrowserRouter>
  );
}

ReactDOM.render(<App />, document.getElementById('root'));
